import { sound } from '@pixi/sound';

import { userSettingsStore } from '../../store/userSettingsStore';

import { PixiAssets } from '../../core/helpers/loadResources';

let pauseTimeOutId = null;
export const SoundTypes = {
  ReelStop: 'ReelStop',
  BackgroundMusic: 'BackgroundMusic',
  Scatter1Win: 'Scatter1Win',
  SevenSymbol: 'SevenSymbol',
  Scatter2Win: 'Scatter2Win',
  SpinButton: 'SpinButton',
  SpinWheelButton: 'spinWheelButton',
  WildSymbol: 'WildSymbol',
  WildOpeningSound: 'WildOpeningSound',
  WinAccumulationSound: 'WinAccumulationSound',
  AmountIncrease: 'AmountIncrease',
  WinningLineSound: 'WinningLineSound',
  WinPopupBigWin: 'WinPopupBigWin',
  WinPopupEpicWin: 'WinPopupEpicWin',
  WinPopupMegaWin: 'WinPopupMegaWin',
  WinPopupSuperWin: 'WinPopupSuperWin',
  WinOneLineSound: 'WinOneLineSound',
  BigWinSound: 'BigWinSound',
  MegaWinSound: 'MegaWinSound',
  SuperWinSound: 'SuperWinSound',
  EpicWinSound: 'EpicWinSound',
  MaxWinSound: 'MaxWinSound',
  WheelSpinning: 'wheelSpinning',
  WheelWinPopup: 'wheelWinPopup',
  OpenWheel: 'openWheel',
  JackpotSymbolSound: 'JackpotSound',
  JackpotSymbol: 'JackpotSymbol',
  JackpotBackgroundMusic: 'JackpotBackgroundMusic',
  JackpotIlluminations: 'Illuminations',
  JackpotSceneTransition: 'SceneTransition',
  JackpotSuitAppearance: 'SuitAppearance',
  JackpotSuitTransfer: 'SuitTransfer',
  JackpotWinPopUp: 'WinPopUp',
};

export const soundOptions = [
  {
    src: 'sounds/spinWheelButton.mp3',
    path: 'sounds/spinWheelButton.mp3',
    name: SoundTypes.SpinWheelButton,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/wheelSpinning.mp3',
    path: 'sounds/wheelSpinning.mp3',
    name: SoundTypes.WheelSpinning,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/wheelWinPopup.mp3',
    path: 'sounds/wheelWinPopup.mp3',
    name: SoundTypes.WheelWinPopup,
    autoplay: false,
    loop: true,
    html5: true,
  },
  {
    src: 'sounds/openWheel.mp3',
    path: 'sounds/openWheel.mp3',
    name: SoundTypes.OpenWheel,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/reelStop.mp3',
    name: SoundTypes.ReelStop,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/spinButton.mp3',
    name: SoundTypes.SpinButton,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/wildSymbol.mp3',
    name: SoundTypes.WildSymbol,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/dollarScatterWin.mp3',
    name: SoundTypes.Scatter2Win,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/starScatterWin.mp3',
    name: SoundTypes.Scatter1Win,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/bigWinSound.mp3',
    name: SoundTypes.BigWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/megaWinSound.mp3',
    name: SoundTypes.MegaWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/epicWinSound.mp3',
    name: SoundTypes.EpicWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/superWinSound.mp3',
    name: SoundTypes.SuperWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/maxWinSound.mp3',
    name: SoundTypes.MaxWinSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/wildOpeningSound.mp3',
    name: SoundTypes.WildOpeningSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/winningLineSound.mp3',
    name: SoundTypes.WinningLineSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/amountIncrease.mp3',
    name: SoundTypes.AmountIncrease,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/winOneLineSound.mp3',
    name: SoundTypes.WinOneLineSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/backgroundMusic.mp3',
    name: SoundTypes.BackgroundMusic,
    autoplay: true,
    loop: true,
    html5: true,
  },
  {
    path: 'sounds/winPopupBigWin.mp3',
    name: SoundTypes.WinPopupBigWin,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/jackpotSymbolSound.mp3',
    name: SoundTypes.JackpotSymbolSound,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/jackpotBackgroundMusic.mp3',
    name: SoundTypes.JackpotBackgroundMusic,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/illuminations.mp3',
    name: SoundTypes.JackpotIlluminations,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/sceneTransition.mp3',
    name: SoundTypes.JackpotSceneTransition,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/suitAppearance.mp3',
    name: SoundTypes.JackpotSuitAppearance,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/suitTransfer.mp3',
    name: SoundTypes.JackpotSuitTransfer,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/winPopUp.mp3',
    name: SoundTypes.JackpotWinPopUp,
    autoplay: false,
    html5: true,
  },
  {
    path: 'sounds/jackpot_Symbol.mp3',
    name: SoundTypes.JackpotSymbol,
    autoplay: false,
    html5: true,
  },
];

const SoundListNames = soundOptions.map((el) => el.name);

class SoundService {
  async play(name, config = {}) {
    if (userSettingsStore.isSoundOn) PixiAssets.get(name).play(config);
  }

  async stop(name) {
    PixiAssets.get(name).stop();
  }

  stopAll() {
    const SoundList = Object.values(PixiAssets.get(SoundListNames));
    SoundList.forEach((sound) => {
      sound.stop();
    });
  }

  stopAllSounds() {
    const SoundList = Object.values(PixiAssets.get(SoundListNames));
    SoundList.forEach((sound) => {
      if (!sound.options.url.includes('Music')) {
        sound.stop();
      }
    });
  }

  playMusic() {
    if (userSettingsStore.isSoundOn) {
      // this.play(SoundTypes.BackgroundMusic, { loop: true });
    }
  }

  pauseSounds() {
    clearTimeout(pauseTimeOutId);
    // this.stopAll();
    sound.pauseAll();
  }

  resumeSounds() {
    clearTimeout(pauseTimeOutId);
    pauseTimeOutId = setTimeout(() => {
      // this.stopAll();
      // sound.resume(SoundTypes.BackgroundMusic);
    }, 2000);
  }
}

const soundService = new SoundService();

export { SoundTypes as soundTypes, soundService };
